<template>
  <div class="dataPack">
    <div class="title">
      <div class="pointer" @click="goNextRep(`/data/dataPackage`)">
        全部资料
      </div>
      <div v-if="detail && detail.courseName">
        <i class="iconfont icon-gengduo" />{{ detail ? detail.courseName : "" }}
      </div>
    </div>
    <div class="content" v-if="detail">
      <div class="check">
        <div class="pageck">
          <div class="pageck-title">
            {{ thisList.materialName }}  
          </div>
        </div>
        <div class="preview-box" v-if="thisList">
          <!-- Office文件预览 -->
          <iframe
            seamless
            v-if="
              thisList.fileType == 'word' ||
              thisList.fileType == 'ppt' ||
              thisList.fileType == 'excel'
            "
           :src="`https://view.officeapps.live.com/op/view.aspx?ui=en-US&rs=en-US&src=${encodeURIComponent(thisList.uploadMaterial)}`"
            width="826px"
            height="100%"
            frameborder="1"
            noResize
          >
          </iframe>
          <!-- PDF文件预览 -->
          <iframe
            seamless
            v-else-if="thisList.fileType == 'pdf'"
            :src="thisList.uploadMaterial + contentDispositionType"
            width="826px"
            height="100%"
            frameborder="1"
            noResize
          >
          </iframe>

          <!-- 其他文件类型 -->
          <div class="other-file" v-else>
            <div class="file-info">
              <i
                class="iconfont icon-a-zu335"
                style="font-size: 60px; color: #ccc"
              ></i>
              <p>{{ thisList.materialName }}</p>
              <p style="color: #999; margin-top: 10px">
                该文件类型不支持在线预览
              </p>
              <button class="download-btn" @click="allDolow(thisList)">
                点击下载
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="pageck">
          <div class="pageck-title">{{ detail.courseName }}</div>
          <!-- <div class="pageck-price">
            ￥{{ detail.currentPrice ? detail.currentPrice : 0 }}
          </div> -->
        </div>
        <div
          class="item pointer"
          v-for="(item, index) in list"
          :key="index"
          :class="thisList.materialId == item.materialId ? 'active' : ''"
          @click.self="choose(item)"
        >
          <div
            v-if="thisList.materialId == item.materialId"
            class="triangle"
          ></div>
          <i
            class="iconfont icon-a-zu335 item-icon"
            @click.self="choose(item)"
          ></i>
          <div class="item-title twoEllipsis" @click.self="choose(item)">
            {{ item.materialName }}
          </div>
        </div>
        <div class="nothing" v-if="!list || list.length == 0">
          <div class="nothing-text">暂无内容哦~</div>
        </div>
        <div class="goumai dolow" @click="allDolow(thisList)">下载当前</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// import { getLbClassCourseById, getClassCourseById, getClass } from "@/api/home";
// import { DataClient } from "@/api/dataClient";
// let dataClient = new DataClient();
// import { Know } from "@/api/know";
// let know = new Know();
import { getToken, getInfo } from "@/api/cookies";
// import { OrderClient } from "@/api/orderClient";
// let orderClient = new OrderClient();
// import kowledgePoints from "@/components/kowledgePoints.vue";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    // kowledgePoints
  },
  data() {
    return {
      classesId: null,
      type: 1,
      courId: null,
      ChatId: null,
      detail: {}, //试卷包详情
      list: {},
      thisList: {}, //当前预览
      userInfo: null,
      packageId: null, //资料包Id
      courseId: null, //课程Id
      textContent: "", //文本文件内容

      IsPurchase: false,
      kowledgePointsVisible: false,
      contentDispositionType: 'contentDispositionType=inline',
    };
  },
  async created() {
    this.userInfo = getInfo();
    if (!this.userInfo) {
      Vue.prototype.goLoginView(true);
      return;
    }
    this.type = this.$route.query.type ? Number(this.$route.query.type) : 1;
    this.ChatId = this.$route.query.ChatId ? this.$route.query.ChatId : null;
    this.courseId = this.$route.query.courseId
      ? this.$route.query.courseId
      : null;
    this.getList();
  },
  methods: {
    // 获取试卷包列表
    getList() {
      homeClient
        .getCourseMaterialList({
          chapterId: this.ChatId,
          attachmentCode: this.type,
        })
        .then((res) => {
          this.list = res.data;
          this.list.forEach((e) => {
            e.fileType = Vue.prototype.getFileType(e.uploadMaterial);
            if (e.uploadMaterial && e.uploadMaterial.includes("?")) {
              this.contentDispositionType = "&" + this.contentDispositionType;
            } else {
              this.contentDispositionType = "?" + this.contentDispositionType;
            }
          });
          if (res.data && res.data.length > 0) {
            this.choose(res.data[0]);
          }
        });
      homeClient
        .queryCourseJxyDetails({
          courseId: this.courseId,
        })
        .then((res) => {
          this.detail = res.data;
        });
    },

    /* 资料选择 */
    choose(item) {
      this.thisList = item;
      // 如果是文本文件，加载内容
      if (item.fileType === "txt") {
        this.loadTextContent(item.uploadMaterial);
      } else {
        this.textContent = "";
      }
    },
    /* 加载文本文件内容 */
    loadTextContent(url) {
      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          this.textContent = data;
        })
        .catch((error) => {
          console.error("加载文本文件失败:", error);
          this.textContent = "无法加载文本文件内容";
        });
    },

    /*立即购买  */
    goOrder() {
      let token = getToken();
      if (token) {
        orderClient
          .addOrders(
            this.detail.id,
            localStorage.getItem("userId"),
            this.detail.title,
            5,
            this.detail.title,
            this.detail.kind
          )
          .then((res) => {
            if (res.code == 0) {
              this.$router.push({
                name: "个人中心订单页",
                params: { orderNumber: res.msg },
              });
            } else {
              this.$message.error(res.msg);
            }
          });
      } else {
        Vue.prototype.goLoginView(true);
        this.$router.push({ name: "登录页", params: { hzc: 1 } });
      }
    },
    /* 全部下载 */
    allDolow(item) {
      window.open(item.uploadMaterial, "_blank");
    },

    iframeAutoFit() {
      try {
        if (window != parent) {
          var a = parent.document.getElementsByTagName("IFRAME");
          for (var i = 0; i < a.length; i++) {
            if (a[i].contentWindow == window) {
              var h1 = 0,
                h2 = 0,
                d = document,
                dd = d.documentElement;
              a[i].parentNode.style.height = a[i].scrollHeight + "px";
              a[i].style.height = "10px";
              if (dd && dd.scrollHeight) {
                h1 = dd.scrollHeight;
              }
              if (d.body) {
                h2 = d.body.scrollHeight;
              }
              var h = Math.max(h1, h2);
              if (document.all) {
                h += 4;
              }
              if (window.opera) {
                h += 10;
              }
              a[i].style.height = a[i].parentNode.style.height = h + "px";
            }
          }
        }
      } catch (ex) {}
    },
  },
};
</script>
<style lang="less" scoped>
.dataPack {
  width: 1146px;
  height: 100%;
  background: #f5f7fa;
  overflow: hidden;
  margin: 0px calc(50% - 573px);
}

.title {
  width: 100%;
  height: 62px;
  line-height: 62px;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(216, 216, 216, 0.7);

  padding: 0px 30px;
  display: flex;
  margin: 40px 0px;

  .iconfont {
    color: #d8d8d8;
    margin: 0px 14px;
  }
}

.content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  .check {
    width: 100%;
    min-height: calc(100vh - 80px - 62px - 90px - 170px - 30px);
    background: #ffffff;

    .pageck {
      border-bottom: 1px solid #f5f6fa;
      padding: 32px 25px;
      border-bottom: 1px solid #dddddd;

      .pageck-title {
        font-size: 22px;
        font-family: MicrosoftYaHei;
        line-height: 22px;
        color: #333333;
      }

      .pageck-price {
        font-size: 24px;
        font-family: DIN Regular;
        line-height: 29px;
        color: #f55752;

        margin-top: 20px;
      }

      .tips {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 15px;
        color: #666666;

        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        align-items: center;

        .tips-item {
          display: flex;

          .tips-item-chil {
            margin-right: 54px;
          }

          .iconfont {
            height: 12px;
            color: #666666;
            margin-right: 8px;
          }
        }
      }
    }

    .preview-box {
      height: calc(100vh - 170px - 30px);
    }
    .image-preview {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f5f5f5;
    }
    .text-preview {
      height: 100%;
      background: #f5f5f5;
    }
    .other-file {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f5f5f5;
    }
    .file-info {
      text-align: center;
    }
    .download-btn {
      margin-top: 20px;
      padding: 10px 20px;
      background: #fd623f;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
    .download-btn:hover {
      background: #ff4a26;
    }
  }

  .list {
    width: 288px;
    min-height: calc(100vh - 80px - 62px - 90px - 170px - 30px);
    background: #ffffff;
    padding: 0px 0px 100px;
    /*  padding: 32px 13px 32px 16px; */
    flex-shrink: 0;
    margin-left: 32px;
    position: relative;

    .pageck {
      border-bottom: 1px solid #f5f6fa;
      padding: 32px 16px 16px;

      .pageck-title {
        font-size: 18px;
        font-family: MicrosoftYaHei;
        line-height: 22px;
        color: #333333;
      }

      .pageck-price {
        font-size: 24px;
        font-family: DIN Regular;
        line-height: 29px;
        color: #f55752;

        margin-top: 20px;
      }
    }

    .item {
      height: 72px;
      background: #fff;

      padding: 15px 13px 16px 17px;
      display: flex;
      align-items: flex-start;
      border-bottom: 1px solid #f5f6fa;
      position: relative;

      .triangle {
        position: absolute;
        width: 14px;
        background: #ff925f;
        transform: rotate(45deg);
        height: 14px;
        top: calc(50% - 5px);
        left: -5px;
      }

      .item-icon {
        font-size: 12px;
        color: #333;
        margin-right: 9px;
        margin-top: 5px;
      }

      .item-title {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        line-height: 22px;
        color: #333;
      }

      .tips_img {
        margin-top: 26px;
      }
    }

    .active {
      background: #ff925f;

      .item-icon {
        color: #ffffff;
      }

      .item-title {
        color: #ffffff;
      }
    }
  }
}

.goumai {
  position: absolute;
  bottom: 30px;
  left: 16px;
  right: 16px;
  height: 40px;
  background: #fd623f;
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  line-height: 40px;
  color: #ffffff;
  cursor: pointer;
}

.dolow {
  position: absolute;
  bottom: 30px;
  left: 16px;
  right: 16px;
  height: 40px;
  border: 1px solid #fd623f;
  opacity: 1;
  background: #fff;
  color: #fd623f;
}

.kowledgePoints_wrap {
  padding-bottom: 20px;

  .determine_btn {
    width: 40%;
    height: 40px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #ff5e51;
    color: #ffffff;
    font-weight: 500;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}
</style>
